<script>
import {objectManipulation, xhr} from "../../tools/functions";
import LanguageSelector from "../../components/LanguageSelector.vue";
import OptionsImageUploader from "../../components/OptionsImageUploader.vue";

export default {
  name: "PackageTourismServices",
  components: {OptionsImageUploader, LanguageSelector},
  mixins: [objectManipulation],
  data: () => ({
    languageCode: null,
    services: {},
    working: false,
    files: {},
    uploadProgress: -1,
    removed_files: []
  }),
  methods: {
    loader(r) {
      if (r.data && r.data.value)
        this.services = JSON.parse(r.data.value)
      if (r.data && r.data.files)
        this.files = r.data.files;
    },
    retrieveSettings() {
      this.working = true;
      xhr(`api/metas/services-packages-defaults-settings/default-tourism-services/${this.languageCode}`, 'get', {withFiles: 1})
          .then(r => this.loader(r))
          .catch(() => {
          })
          .finally(() => this.working = false)
    },
    onSave() {
      if (this.working) return;
      this.working = true;
      this.uploadProgress = 0;
      const fd = new FormData();
      fd.append('data', new Blob([JSON.stringify(this.services)], {type: 'application/json'}), 'data.json')
      fd.append('withFiles', 1);
      this.$el.querySelectorAll('input[type=file][data-key]').forEach(x => {
        if (x.files.length > 0) {
          fd.append(x.getAttribute('data-key'), x.files[0]);
        }
      })
      if (this.removed_files && this.removed_files.length > 0)
        fd.append('removed_files', JSON.stringify(this.removed_files));
      xhr(`api/metas/services-packages-defaults-settings/default-tourism-services/${this.languageCode}`,
          'post', fd, pc => this.uploadProgress = pc)
          .then(r => {
            this.loader(r);
            this.removed_files = [];
          })
          .finally(() => {
            this.working = false;
            this.uploadProgress = -1;
          })
    }
  },
  mounted() {
    this.$on('remove-image', e => {
      this.removed_files.push(...e);
    })
  }
}
</script>

<template>
  <div>
    <div class="alert alert-light text-body">
      <div class="d-flex align-items-center font-weight-bolder">
        <div class="font-weight-bolder h4 mr-3 mb-0">تنظیمات خدمات گردشگری پیشفرض برای پکیج ها</div>
        <language-selector v-model="languageCode" class="form-control w-auto" @input="retrieveSettings"/>
        <button type="button" class="btn btn-primary ml-3" :disabled="working"
                @click="retrieveSettings">
          دریافت تنظیمات
        </button>
        <div v-if="working" class="ml-auto alert alert-warning my-0 small py-1">درحال تبادل اطلاعات</div>
      </div>

      <div class="row my-4">
        <div class="col-sm-4 mt-2" v-for="(t,tk) in services" :key="tk">
          <div class="p-2 bg-light border border-info h-100 rounded">
            <label>
              <div class="form-label">عنوان</div>
              <input type="text" class="form-control" v-model="t.title"/>
            </label>
            <label class="mt-2">
              <div class="form-label">توضیحات</div>
              <textarea class="form-control" v-model="t.description"></textarea>
            </label>
            <label>
              <div class="form-label">قیمت</div>
              <input type="text" class="form-control" v-model="t.price" pattern="\d+"/>
            </label>
            <label>
              <div class="form-label">قیمت داخلی</div>
              <input type="text" class="form-control" v-model="t.local_price" pattern="\d+"/>
            </label>
            <options-image-uploader :files="files"
                                    :data-key="tk"
                                    label="تصویر بند انگشتی"/>
            <div class="mt-2">
              <button type="button" class="btn btn-danger w-100 mt-2"
                      @click="deleteObject(services,tk,tk)">
                حذف
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-4 mt-2 d-flex flex-column justify-content-center align-center bg-light">
          <button type="button" class="btn btn-primary" :disabled="working"
                  @click="addObject($data,'services',Date.now().toString(36))">
            افزودن خدمت
          </button>
        </div>
      </div>
    </div>
    <div class="alert alert-light text-body mt-4 mx-0 sticky-bottom shadow d-flex align-items-center">
      <div class="progress flex-fill mr-2" v-if="uploadProgress >= 0">
        <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
             :style="{width: uploadProgress + '%'}" aria-valuenow="25" aria-valuemin="0"
             aria-valuemax="100"></div>
      </div>
      <span class="mr-auto"></span>
      <button type="button" class="btn btn-primary" @click="onSave" :disabled="working">
        ذخیره تغییرات
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>